var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-menu-item',{attrs:{"index":"/overview"}},[_c('router-link',{staticClass:"sub-menu-link",attrs:{"to":"/overview"}},[_c('div',{staticClass:"img-wrapper"},[_c('img',{staticStyle:{"height":"100%","width":"100%"},attrs:{"src":require("@src/assets/navbar/overview-map.svg")}})]),_c('span',[_vm._v(" "+_vm._s(_vm.$t('navbar.overview')))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }